<template>
  <vue-multiselect
    ref="multiselect"
    v-bind="{ ...$attrs, ...$props }"
    :class="classList"
    class="app-multiselect"
    v-on="$listeners"
  >
<!--    <template v-slot:caret>-->
<!--      <span class="multiselect-dropdown-icon" @click="closeOnOpen">-->
<!--        <i class="fa fa-angle-down"></i>-->
<!--      </span>-->
<!--    </template>-->

    <template v-slot:option="{ option }">
      <slot :option="option" name="optionSlot"></slot>
    </template>

    <template v-slot:singleLabel="{ option }">
      <slot
          :option="option"
          name="singleLabel">
      </slot>
    </template>

    <template v-if="! taggable" slot="selection" slot-scope="{ values, search, isOpen }">
      <span v-if="values.length" class="multiselect__single">
        {{ values.length }} optie<span v-if="values.length !== 1">s</span> geselecteerd
      </span>
    </template>

    <template v-slot:noResult>
      <slot name="noSearchResults">
        Geen resultaten gevonden
      </slot>
    </template>

    <template v-slot:noOptions>
      <slot name="noOptions">
        Geen items gevonden
      </slot>
    </template>
  </vue-multiselect>
</template>

<script>
  import VueMultiselect from 'vue-multiselect';

  export default {
    name: 'AppMultiselect',

    components: { VueMultiselect },

    props: {
      id: {
        type: String,
        default: null,
      },

      taggable: {
        type: Boolean,
        default: false,
      },

      tagPlaceholder: {
        type: String,
        default: null,
      },

      selectLabel: {
        type: String,
        default: null,
      },

      deselectLabel: {
        type: String,
        default: null,
      },

      popover: {
        type: Boolean,
        default: false,
      },

      bordered: {
        type: Boolean,
        default: false,
      },

      compact: {
        type: Boolean,
        default: false,
      },

      showPointer: {
        type: Boolean,
        default: false,
      }
    },

    computed: {
      classList() {
        return {
          'app-multiselect__popover': this.popover,
          'app-multiselect__bordered': this.bordered,
          'app-multiselect__compact': this.compact,
        };
      }
    },

    methods: {
      activate() {
        this.$refs.multiselect.activate();
      },

      deactivate() {
        this.$refs.multiselect.deactivate();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/AppMultiselect.vue